export default __webpack_public_path__ + "static/media/completed.8cd5b5aa.svg";